var exports = {
  "x6": "MemberListItem.module__button___LXc5Uz",
  "OG": "MemberListItem.module__nameRoleColored___LXc5Uz",
  "w1": "MemberListItem.module__buttonOffline___LXc5Uz",
  "dP": "MemberListItem.module__buttonContextMenuOpen___LXc5Uz",
  "vs": "MemberListItem.module__memberFocusRing___LXc5Uz",
  "Vg": "MemberListItem.module__grid___LXc5Uz",
  "Qs": "MemberListItem.module__content___LXc5Uz",
  "H": "MemberListItem.module__avatarContainer___LXc5Uz",
  "TT": "MemberListItem.module__userInfoContainer___LXc5Uz",
  "VW": "MemberListItem.module__nameContainer___LXc5Uz",
  "UU": "MemberListItem.module__name___LXc5Uz",
  "w4": "MemberListItem.module__memberCustomStatus___LXc5Uz",
  "Dd": "MemberListItem.module__ownerIcon___LXc5Uz",
  "j$": "MemberListItem.module__crownIcon___LXc5Uz",
  "a1": "MemberListItem.module__userTag___LXc5Uz",
};

module.exports = exports;
